export default {
    grok: { "rawSubmit": 'Your input will be submitted unchanged. The provider processes it and returns the result.', "unavailableTitle": 'Currently unavailable', "step2": 'Submit Grok sso', "ssoLabel": "Grok sso", "placeholder": "Paste grok.com sso, a Cookie header, or JSON with sso", "guide": "Sign in to grok.com. In browser developer tools, open Application / Storage → Cookies → grok.com and copy the full sso value. This is a sensitive login credential; never share it publicly.", "accountPending": "Account available after processing", "countryHint": "The subscription will be opened using this billing country. Existing account currency is not checked.", "promo": "First-month promotion", "eligible": "Eligible", "ineligible": "Not eligible", "disabled": "Grok redemption is currently unavailable. Refresh later or contact support." },
    common: {
        retryAfter: 'Too many requests. Wait {seconds} seconds before retrying.',
        documentTitle: 'GPT兑换站',
        back: '← Back',
        backHome: '← Back to Home',
        loading: 'Loading...',
        submitting: 'Submitting...',
        querying: 'Querying...',
        retry: 'Search Again',
        selectPlaceholder: 'Select',
    },
    language: {
        switchToEnglish: 'Switch to English',
        switchToChinese: 'Switch to Chinese',
    },
    home: {
        brand: 'GPT Exchange Station',
        brandSub: 'ChatGPT Account Exchange',
        heroTitle: 'Recharge & Account Upgrade Service',
        heroSub: 'Verify your account and CDK, then confirm — step by step',
        sectionDescriptions: {
            recharge: 'Verify a CDK and submit the account session for a secure, trackable recharge request.',
            query: 'Enter one or more CDKs to check task status and processing progress.',
            subscription: 'View the account plan, expiry date, and automatic renewal status in real time.',
            refresh: 'Replace an eligible CDK and save the new code promptly.',
            cancel: 'Cancel a recharge task that is still queued and has not started processing.',
        },
        flowTitle: 'How It Works',
        tabsAria: 'Recharge portal sections',
        announcementLabel: 'Notice',
        announcementAria: 'Recharge page announcement',
        services: {
            recharge: { title: 'Recharge', en: 'Service Portal', cta: 'Start Recharge', p1: 'Verify CDK code', p2: 'Submit session', p3: 'Confirm submission' },
            lookup: { title: 'Task Lookup', en: 'Task Lookup', cta: 'Check Status', p1: 'Look up by CDK', p2: 'View task status', p3: 'Track progress' },
        },
        flows: {
            submit: { title: 'Submit Flow', s1: 'Verify CDK — check code status', s2: 'Submit session — paste the JSON from chatgpt.com/api/auth/session', s3: 'Confirm and submit' },
            lookup: { title: 'Lookup Flow', s1: 'Enter CDK — the code used at purchase', s2: 'Query task — click the search button', s3: 'View status — see the matching task status' },
        },
    },
    queue: {
        pendingLabel: 'Pending in Console',
        unit: 'tasks',
        loading: 'Syncing',
        syncing: 'Live sync on',
        polling: 'Periodic sync on',
        reconnecting: 'Reconnecting automatically',
    },
    recharge: {
        batchModeAria: 'Recharge mode',
        singleMode: 'Single recharge',
        batchMode: 'Batch recharge',
        maintenanceTitle: 'Recharge service notice',
        billingCountry: 'Billing region',
        billingCountryHint: 'Use an account billed in this region. An existing subscription with a different billing currency will be rejected.',
        billingCountryUnrestricted: 'This code has no billing region restriction.',
        noCountryRestriction: 'No region restriction',
        serviceClosed: 'Recharge temporarily closed',
        keepPageOpen: 'Payment may require human verification. Please keep this page open.',
        subscriptionAdvisoryChecking: 'Checking the subscription for your reference. You can continue to the next step.',
        subscriptionAdvisoryUnavailable: 'Subscription status is unavailable. You can still submit; the provider will check it when processing.',
        subscriptionAdvisoryActive: 'Current subscription: {plan}. The provider determines eligibility when processing your order.',
        subscriptionAdvisoryProvider: 'Account status is for reference. The provider determines eligibility when processing your order.',
        channelLabel: 'Recharge channel',
        title: 'Recharge',
        subtitle: 'Service Portal · Account recharge request',
        steps: { s1: 'Verify CDK', s2: 'Submit Session', s3: 'Confirm' },
        step1Title: 'Verify CDK Code',
        cdkLabel: 'CDK Code',
        cdkValid: '✓ CDK valid',
        cdkPending: 'This CDK is being processed',
        cdkPendingHint: 'Auto-checking… if the task fails it will become submittable again automatically, no refresh needed',
        planType: 'Plan Type',
        verifying: 'Verifying...',
        verifyButton: 'Verify CDK',
        next: 'Next →',
        prev: '← Previous',
        restart: 'Start Over',
        step2Title: 'Submit Session',
        progressAria: 'Recharge progress',
        sessionGuidePrefix: 'After logging into ChatGPT, open in your browser',
        sessionGuideSuffix: ', copy the full JSON returned, and paste it into the box below.',
        sessionGuideTitle: 'Get your Session correctly in 3 steps',
        sessionGuideSubtitle: 'Use the account you want to recharge and follow these steps in order',
        sessionGuideBadge: '3 quick steps',
        sessionGuideStep1: 'Sign in to ChatGPT and confirm that this is the account you want to recharge.',
        sessionGuideStep2: 'While still signed in, open this page in the same browser:',
        sessionGuideOpenLink: 'Open Session page',
        sessionGuideStep3: 'When the JSON appears, press Ctrl/Cmd+A, then Ctrl/Cmd+C, and paste the complete result into the field below.',
        sessionGuideAutoCheck: 'After pasting, the system validates the Session. The server checks the account status again while processing.',
        sessionGuideRenewalAutoCheck: 'After pasting, the system checks the Session format. The recharge backend validates it after submission.',
        sessionGuideTrouble: 'Blank page, null, or a sign-in message? Sign in to ChatGPT again, then reopen the Session page.',
        sessionGuideNoticeTitle: 'Security note:',
        sessionGuideNotice: 'Copy the complete JSON, not only the accessToken. A Session contains sensitive sign-in data—never send it to anyone else.',
        sessionLabel: 'Session JSON',
        step3Title: 'Confirm & Submit',
        sessionStatus: 'Session Status',
        sessionFilled: '✓ Provided',
        sessionChecking: 'Checking the account subscription in real time...',
        sessionFreeVerified: '✓ Session verified; eligible for this card',
        sessionFormatValid: '✓ Session format passed; the recharge backend validates it after submission',
        submitSuccessTitle: '✓ Request submitted successfully!',
        taskId: 'Task ID',
        submitSuccessHint: 'Task progress updates automatically. Payment may require human verification; keep this page open.',
        confirmSubmit: 'Confirm & Submit',
        errInvalidCdk: 'Invalid CDK',
        errVerifyFailed: 'Verification failed',
        errCreateFailed: 'Failed to create task',
        errConfirmFailed: 'Submission failed',
        errNetwork: 'Network error',
        errSessionRequired: 'Please paste the complete Session JSON',
        errSessionInvalidJson: 'Invalid Session JSON. Please copy and paste the complete JSON',
        errSessionMissingAccessToken: 'Incomplete Session JSON: accessToken was not found',
        errSessionMissingSessionToken: 'Incomplete Session JSON: sessionToken was not found',
        errSessionMissingEmail: 'Incomplete Session JSON: account email was not found',
        errSessionPlanNotFree: 'The live lookup returned plan {planType}, which is not eligible for this card',
        errSessionActiveSubscription: 'The account is on the same or a higher tier than this card and cannot be submitted',
        errSessionPlanUnknown: 'The active subscription status could not be confirmed. Please try again shortly',
        errRechargePlanUnknown: 'This card plan could not be recognized. Verify the card again or contact the administrator',
        errQuotaAccountNotEligible: 'This account is not eligible for the quota card. Check the card requirements',
        errSessionCheckFailed: 'Could not check the subscription status. Please try again shortly',
        errSessionCheckRequired: 'This Session has not passed the live tier check for this card. Please check it again',
        errSessionFormatCheckRequired: 'This Session has not passed the format check. Check the complete JSON and try again',
        refreshCdk: 'Refresh code ({count} left)',
        refreshSuccess: 'Code refreshed; the new code is ready',
        refreshFailed: 'Code refresh failed. Please try again later.',
    },
    history: {
        bankVerificationNeeded: 'Bank verification required. Open this task.',
        verificationNeeded: 'Verification required — open this task',
        replaced: 'Code replaced',
        queryFailed: 'Task lookup is temporarily unavailable. Try again later; do not resubmit an existing order.',
        title: 'Task Lookup',
        subtitle: 'Task Lookup · Check recharge task status by CDK',
        queryTitle: 'Lookup by CDK',
        queryHint: 'Enter the CDK used at purchase; the matching task status will be shown here.',
        queryPlaceholder: 'Enter the CDK code used at purchase',
        batchQueryTitle: 'Batch CDK Lookup',
        batchQueryHint: 'Paste multiple CDKs at once (up to 100), separated by new lines, spaces, commas, or semicolons. Duplicates are removed automatically.',
        batchQueryPlaceholder: 'One CDK per line, or separate multiple codes with commas',
        detectedCodes: '{count} unique CDKs detected',
        clearQuery: 'Clear Query',
        cdkLabel: 'CDK Code',
        queryBtn: 'Query Task',
        batchQueryBtn: 'Batch Query',
        queryErrorTitle: 'Query Failed',
        resultTitle: 'Result',
        liveRefreshing: 'Auto-refreshing in-progress tasks…',
        batchResultTitle: 'Batch Results',
        batchSummaryTitle: 'Lookup Overview',
        batchSummaryText: '{found}/{total} tasks found, {unused} unused.',
        batchSummaryTextWithMissing: '{found}/{total} tasks found, {unused} unused, {notFound} need checking.',
        batchStatsAria: 'Batch lookup statistics',
        totalQueried: 'Total',
        foundCount: 'Found',
        processingCount: 'Processing',
        failedCount: 'Failed',
        unusedCount: 'Unused',
        notFoundCount: 'Needs Checking',
        batchListAria: 'Batch lookup result list',
        accountUnknown: 'Account not recorded',
        unusedShort: 'Unused',
        unusedHint: 'This CDK has not been submitted for recharge',
        unusedWithPlan: 'No task submitted · {plan}',
        notFoundShort: 'Not Found',
        copyUnused: 'Copy Unused',
        copyUnusedSuccess: 'Copied {count} unused CDKs.',
        copyUnusedFailed: 'Copy failed. Please copy manually.',
        maxBatchExceeded: 'You can query up to {max} CDKs at a time. Please split the list and try again.',
        taskId: 'Task ID',
        cdkCode: 'CDK Code',
        subscriptionType: 'Subscription Type',
        rechargeAccount: 'Recharge Account',
        currentStatus: 'Current Status',
        failureReason: 'Failure Reason',
        detailTitle: 'Task Details',
        submitTime: 'Submitted At',
        completeTime: 'Completed At',
        queryOther: 'Query Another Task',
        detailActionsAria: 'Task actions',
        copyCdk: 'Copy CDK',
        copyAccount: 'Copy Account',
        resubmit: 'Resubmit',
        refreshCdk: 'Refresh code',
        cancelTask: 'Cancel queued task',
        cancelTaskConfirm: 'Cancel this task before processing starts? You can submit the code again afterward.',
        cancelTaskSuccess: 'Task cancelled; the code can be submitted again',
        cancelTaskFailed: 'Cancel failed. Refresh the status and try again.',
        copyCdkSuccess: 'CDK copied',
        copyAccountSuccess: 'Account copied',
        copyActionFailed: 'Copy failed. Please copy manually.',
        selectTaskTitle: 'Select a task to view details',
        selectTaskHint: 'Click any found task on the left to see its full details here.',
        notFoundTitle: 'No task found for this CDK',
        notFoundHint: 'Please check whether the CDK is correct',
        msgPending: '⏳ Task is waiting to be processed, please wait...',
        msgSubmitted: '⚙ Task is being processed, please wait...',
        msgConfirming: 'The preparation or recharge result is being checked. Query the original order; do not resubmit.',
        msgManualReview: '⏳ Processing in the background. Please wait...',
        msgCompleted: '✓ Task completed, your account has been upgraded',
        msgFailed: '✗ Task failed, please resubmit or contact support',
        resultHeadline: { pending: 'Waiting for Confirmation', submitted: 'Processing in Console', confirming: 'Confirming Recharge Result', manual_review: 'Processing in Background', completed: 'Recharge Completed', failed: 'Recharge Failed' },
        status: { pending: 'Pending', submitted: 'Processing', confirming: 'Confirming Recharge Result', manual_review: 'Processing in Background', completed: 'Completed', failed: 'Failed' },
    },
    refresh: {
        title: 'Refresh Code',
        feedbackTitle: 'Refresh notice',
        hint: 'Codes allow up to 3 refreshes with a 60-second cooldown when unused or failed. A successful refresh invalidates the old code.',
        check: 'Check Eligibility',
        checking: 'Checking...',
        submit: 'Refresh Code',
        submitting: 'Refreshing...',
        clear: 'Clear',
        remaining: 'Refreshes remaining: {count}',
        notEligible: 'This code is not currently eligible for refresh',
        failed: 'Refresh failed',
        success: 'Code refreshed — save the new code now',
        saveWarning: 'The new code is only shown here. Copy and save it before leaving this page.',
        oldCode: 'Old code',
        newCode: 'New code',
        copy: 'Copy new code',
        copySuccess: 'New code copied',
        batch: {
            cooldownWaiting: 'Wait {seconds} seconds before retrying.',
            closedQualification: 'Recharge is closed, so refresh eligibility and remaining uses are unknown. You may confirm a refresh request for the server to decide.',
            notChecked: 'Not checked because the batch was rate limited. Retry the check after waiting.',
            deferredStatus: 'Server decision required',
            modeAria: 'Refresh mode',
            singleMode: 'Single refresh',
            batchMode: 'Batch refresh',
            title: 'Batch refresh',
            hint: 'Check eligibility one code at a time, then confirm the dispatch. Save each result promptly.',
            inputLabel: 'Batch CDK input',
            placeholder: 'One code per line, or separate codes with spaces, commas, or semicolons',
            inputHint: 'Duplicates are removed case-insensitively while preserving the first spelling, up to 100 codes. Ineligible, pending, or exhausted codes are skipped.',
            detected: '{count} unique codes detected',
            inputErrorTitle: 'Batch check cannot start',
            empty: 'Enter at least one code first.',
            maxExceeded: 'You can process up to {max} codes at a time. Split the list and try again.',
            check: 'Check batch eligibility',
            recheck: 'Recheck eligibility',
            checking: 'Checking...',
            clear: 'Clear',
            retryFailed: 'Retry failed items ({count})',
            summary: '{ready} awaiting confirmation · {success} succeeded · {failed} failed · {unknown} unconfirmed',
            listAria: 'Batch refresh results',
            resultsTitle: 'Results',
            remaining: '{count} refreshes left',
            status: { checking: 'Checking', ready: 'Eligible', skipped: 'Skipped', verifyError: 'Eligibility check failed', refreshing: 'Refreshing', success: 'Succeeded', failed: 'Explicit failure', unknown: 'Unconfirmed result' },
            pending: 'This code is being processed and was skipped.',
            notEligible: 'This code is not currently eligible for refresh.',
            verifyUnconfirmed: 'Eligibility check did not complete. Retry the check; no refresh was sent.',
            businessFailed: 'The refresh request was rejected. Check eligibility again before retrying.',
            unknownResult: 'Result unconfirmed. Check first or contact an administrator; do not refresh again.',
            readyHint: 'These codes have been checked for refresh eligibility.',
            confirm: 'Confirm batch refresh ({count} codes)',
            confirmText: 'Refresh {count} codes now? The old codes become invalid immediately. Save the new codes, and do not repeat a refresh when a result is unconfirmed.',
            refreshing: 'Refreshing batch...',
            progress: 'Processing {done}/{total}',
            complete: 'Complete: {success} succeeded, {failed} failed, {unknown} unconfirmed.',
            throttledTitle: 'Request throttled',
            throttled: 'The server returned a rate limit. Further refreshes stopped; remaining eligible codes are still ready for a later manual confirmation.',
            copyAll: 'Copy all new codes',
            copySuccess: 'Copied {count} new codes.',
            copyFailed: 'Copy failed. Please copy manually; the results remain listed.',
            download: 'Download TXT',
            downloadSuccess: 'Result TXT downloaded.',
            discardConfirm: 'Some batch results are unsaved or unconfirmed. Clear them and start a new batch?',
        },
    },
    cancellation: {
        title: 'Cancel Task',
        hint: 'Enter the CDK for the task you want to cancel. Only queued tasks that have not started processing can be cancelled. After cancellation, you can submit the code again.',
        clear: 'Clear',
        cancelling: 'Cancelling...',
    },
    subscription: {
        fieldRemainingValue: 'Remaining value',
        plusPromo: 'Plus 50% promotion',
        cancelRenewal: 'Cancel auto-renewal',
        cancellingRenewal: 'Cancelling…',
        cancelRenewalConfirm: 'Cancel auto-renewal for {plan} on account {account}? Access continues until the current period ends. There is no refund or immediate termination; no further renewal charges will be made.',
        cancelUnknown: 'The cancellation result is unconfirmed. Query the subscription again before retrying; cancellation will not be resent automatically.',
        cancelFailed: 'Could not cancel auto-renewal. Query the subscription status first.',
        cancelSucceeded: 'Auto-renewal cancelled. Access continues until the current period ends.',
        cancelRefreshFailed: 'Cancellation succeeded, but refreshing the subscription failed. Please query again.',
        title: 'Subscription',
        inputLabel: 'Enter Session',
        inputPlaceholder: 'Paste the full JSON from chatgpt.com/api/auth/session, or an accessToken directly',
        inputHint: 'Used only to check the subscription status in real time; your session is never stored. Full session JSON or accessToken both work.',
        queryBtn: 'Check Subscription',
        clear: 'Clear',
        queryErrorTitle: 'Query Failed',
        queryFailed: 'Subscription lookup failed, please try again',
        errInvalidInput: 'Invalid session format. Paste the full session JSON or a bare accessToken.',
        errInvalidSession: 'Session is invalid or expired. Please get a fresh one and retry.',
        errRateLimited: 'Too many requests, please try again shortly.',
        resultTitle: 'Subscription',
        statusActive: 'Active subscription with auto-renewal on',
        statusCancelling: 'Active subscription, but auto-renewal is off',
        statusInactive: 'No active subscription on this account',
        badgeActive: 'Active',
        badgeInactive: 'None',
        cancelledNotice: 'Auto-renewal is off. The subscription will stop at the end of the current period with no further charges.',
        willRenewNotice: 'Auto-renewal is on. You will be charged again on {date}.',
        inactiveNotice: 'This account has no active subscription.',
        yes: 'Yes',
        no: 'No',
        renewOn: 'On',
        renewOff: 'Off',
        planFree: 'Free',
        detailTitle: 'Details',
        fieldAccount: 'Account',
        fieldPlan: 'Plan',
        fieldActive: 'Active',
        fieldWillRenew: 'Auto-renew',
        fieldExpires: 'Expires',
        fieldRemainingDays: 'Remaining days',
        remainingDaysValue: '{days} days',
        remainingDaysUnavailable: 'Unable to calculate',
        fieldRenews: 'Renews',
        fieldCancels: 'Cancels at',
        fieldBillingPeriod: 'Billing period',
        fieldPlatform: 'Purchase platform',
        periodMonthly: 'Monthly',
        periodYearly: 'Yearly',
        periodWeekly: 'Weekly',
        platformWeb: 'ChatGPT Web',
        platformIos: 'iOS (App Store)',
        platformGoogle: 'Android (Google Play)',
    },
    login: {
        title: 'Admin Login',
        subtitle: 'Log in to access the admin console, CDK management and task processing.',
        username: 'Username',
        usernamePlaceholder: 'Enter username',
        password: 'Password',
        passwordPlaceholder: 'Enter password',
        rememberPassword: 'Remember password',
        rememberPasswordHint: 'Saved only in this browser and cleared when unchecked',
        loginBtn: 'Sign In',
        loggingIn: 'Signing in...',
        errLoginFailed: 'Login failed',
        errNetwork: 'Network error, please try again later',
    },
    notFound: {
        title: 'Page Not Found',
        home: 'Back to Home',
    },
};
